import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';

import RustSvgColor from '../assets/rust.svg';

export const RustColor = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="color-lang-rust" className={cx('sdkIcon', className)} size={size} {...props}>
    <RustSvgColor />
  </LegacyIcon>
);
